import env from "../../utils/env";

let MediaService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("media/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": { editable: false },
            "externalHashedId": {},
            "name": {},
            "mediaStatus": {},
            "mediaReviewStatus": {},
            "thumbnailUrl": {},
            "width": {},
            "height": {},
            "duration": {},
            "mediaType": {},
            "userId": {},
            "id": {},
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  return { getDataSource };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`media/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if(type == "read") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if(type == "update") {
    return JSON.stringify(data);
  }
}

export default MediaService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/media.service.js
 **/